module.exports = __webpack_public_path__ + "img/2021.06-CNAS-GLP.2fbf9681.jpg";